export default "__VITE_ASSET__BKgYTZdC__"